// This is for dev purposes
var availableTags = [
	"ActionScript",
	"AppleScript",
	"Asp",
	"BASIC",
	"C",
	"C++",
	"Clojure",
	"COBOL",
	"ColdFusion",
	"Erlang",
	"Fortran",
	"Groovy",
	"Haskell",
	"Java",
	"JavaScript",
	"Lisp",
	"Perl",
	"PHP",
	"Python",
	"Ruby",
	"Scala",
	"Scheme"
];

// Time out because of Svelte
setTimeout(() => {
	const autocompleteOptions = {
		source: '/api/search/autocomplete',
		//source: availableTags,
		minLength: 3,
		select: (e, ui) => {
			e.target.value = ui.item.value;
			e.target.form.submit();
		},
	};

	// Jquery AutoComplete call
	$('#site-search').autocomplete($.extend({}, autocompleteOptions, {
		appendTo: '.autocomplete-container',
		classes: {
			'ui-autocomplete': 'gfh-autocomplete'
		},
	}));

	$('#site-search-results').autocomplete($.extend({}, autocompleteOptions, {
		appendTo: '.search-bar',
	}));

}, 1000)